import { cn } from "~/lib/utils";

// // // //

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
}

/**
 * VisualizationGrid
 * Renders a grid for displaying multiple visualizations
 */
export function VisualizationGrid(props: Props) {
    const { className, children, ...rest } = props;
    return (
        <div
            {...rest}
            className={cn("grid grid-cols-1 lg:grid-cols-12 gap-6", className)}
        >
            {props.children}
        </div>
    );
}
